"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromB64ToArray = exports.fromBufferToUtf8 = exports.fromBufferToB64 = exports.fromUtf8ToArray = void 0;
const web_encoding_1 = require("web-encoding");
function fromUtf8ToArray(str) {
    return new web_encoding_1.TextEncoder().encode(str);
}
exports.fromUtf8ToArray = fromUtf8ToArray;
function fromBufferToB64(buffer) {
    return Buffer.from(buffer).toString("base64");
}
exports.fromBufferToB64 = fromBufferToB64;
function fromBufferToUtf8(buffer) {
    return new web_encoding_1.TextDecoder().decode(buffer);
}
exports.fromBufferToUtf8 = fromBufferToUtf8;
function fromB64ToArray(str) {
    return Buffer.from(str, "base64");
}
exports.fromB64ToArray = fromB64ToArray;
